var $ef957358eac33027$exports = {};
$ef957358eac33027$exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};


export {$ef957358eac33027$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
